/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import EasySwipe from 'react-easy-swipe';
import { Modal, useBreakpoint } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import CloseIcon from '@shared/assets/icons/CloseIcon';
import warning from '@shared/assets/images/cyber/warning.png';
import { ButtonDone } from './ButtonDone';
interface PromoEndModalProps {
  open: boolean;
  onClose: () => void;
}
const PromoEndModal: FC<PromoEndModalProps> = ({
  open,
  onClose
}) => {
  const [isClosing, setIsClosing] = useState(true);
  const [swipeDirection, setSwipeDirection] = useState('');
  const {
    isMobile
  } = useBreakpoint();
  const onSwipeStart = () => {
    setSwipeDirection('');
  };
  const onSwipeMove = position => {
    const direction = position.y > 0 ? 'up' : 'down';
    setSwipeDirection(direction);
  };
  const onSwipeEnd = () => {
    if (swipeDirection === 'up') {
      handleCloseModal();
    }
  };
  useEffect(() => {
    if (!open) return;
    setIsClosing(false);
  }, [open]);
  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      // setIsClosing(false)
      onClose();
    }, 400);
  };
  return <StyledModal isClosing={isClosing} open={open} onClose={isMobile ? handleCloseModal : onClose} closeIcon={<CloseIconWrapper>
          <CloseIcon />
        </CloseIconWrapper>} size="md">
      {/* @ts-ignore */}
      <EasySwipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
        <Modal.Body>
          <Image priority src={warning} alt="repair" width={120} height={120} />
          <Spacer space={14} spacetablet={14} spacemob={14} />

          <Heading>Акция завершена</Heading>

          <Spacer space={24} spacetablet={24} spacemob={24} />

          <NoticeButtonsWrapper>
            <div style={{
            width: '335px',
            margin: '0 auto'
          }}>
              <ButtonDone modal title="Понятно" onClick={isMobile ? handleCloseModal : onClose} />
            </div>
          </NoticeButtonsWrapper>
        </Modal.Body>
      </EasySwipe>
    </StyledModal>;
};
export default PromoEndModal;
interface StyledModalProps {
  isClosing: boolean;
  open: boolean;
}
const _exp = /*#__PURE__*/() => Modal;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp3 = /*#__PURE__*/() => ({
  isClosing
}) => isClosing ? 'translateY(100%)' : 'translateY(0)';
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.secondary;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const StyledModal = withTheme(/*#__PURE__*/styled(_exp())({
  name: "StyledModal",
  class: "s1yem4gy",
  propsAsIs: true,
  vars: {
    "s1yem4gy-0": [_exp2(), "px"],
    "s1yem4gy-1": [_exp3()],
    "s1yem4gy-2": [_exp4()],
    "s1yem4gy-3": [_exp5()]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.md;
const Heading = withTheme(/*#__PURE__*/styled('div')({
  name: "Heading",
  class: "hfcy7m8",
  propsAsIs: false,
  vars: {
    "hfcy7m8-0": [_exp6()],
    "hfcy7m8-1": [_exp7(), "px"],
    "hfcy7m8-2": [_exp8()],
    "hfcy7m8-3": [_exp9()],
    "hfcy7m8-4": [_exp0(), "px"]
  }
}));
const NoticeButtonsWrapper = /*#__PURE__*/styled('div')({
  name: "NoticeButtonsWrapper",
  class: "n1ojxvdj",
  propsAsIs: false
});
const CloseIconWrapper = /*#__PURE__*/styled('div')({
  name: "CloseIconWrapper",
  class: "cfj5ttu",
  propsAsIs: false
});

require("./PromoEndModal.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PromoEndModal.tsx");